import { fromLonLat } from "ol/proj";

export const EXTENT = [
  ...fromLonLat([74.5, 56.0]),
  ...fromLonLat([89.7, 61.0]),
];
export const MIN_ZOOM = 10;
export const MAX_ZOOM = 19;
